// src/utils/geoUtils.js

const REGION_MAP = {
  'Los_Angeles': [900, 901, 902, 903, 904, 905, 906, 907, 908, 910, 911, 912, 913, 914, 915, 916, 917, 918],
  'Orange_County': [926, 927, 928],
  'San_Diego': [919, 920, 921],
  'Inland_Empire': [922, 923, 924, 925],
  'Las_Vegas': [889, 890, 891, 893]
};

/**
 * Detects the Scrimly Market Region based on a 5-digit Zip Code
 * SAFELY handles both Numbers (92618) and Strings ("92618")
 */
export const resolveMarketFromZip = (zipInput) => {
  // 1. Safety Check: If missing, return null
  if (!zipInput) return null;

  // 2. Convert to String explicitly (Fixes the crash)
  const zip = String(zipInput).trim();

  // 3. Validate Length
  if (zip.length < 3) return null;
  
  // 4. Extract SCF (first 3 digits)
  const scf = parseInt(zip.substring(0, 3), 10);
  
  // 5. Find Match
  for (const [market, ranges] of Object.entries(REGION_MAP)) {
    if (ranges.includes(scf)) return market;
  }
  
  return null; // Not in a hotspot
};